<template>
    <div v-if="item">
        <v-layout>
            <div class="method-api">
                <v-select
                    hide-details outlined
                    v-model="itemValue.method"
                    :items="methodList"
                    class="input-custom"
                    :readonly="!editable"
                ></v-select>
            </div>
            <div class="url-path">
                <v-text-field
                    hide-details outlined
                    v-model="url"
                    class="input-custom"
                    @focusout="itemValue.url = url"
                    :readonly="!editable"
                ></v-text-field>
            </div>
        </v-layout>
        <v-tabs slider-color="#FFFFFF" grow v-model="activeTabAPI">
            <v-tab v-for="tab in APITabs" :key="tab.id">{{ tab.name }}</v-tab>
            <v-tabs-items>
                <v-tab-item class="api-config">
                    <ApiParameterEditor
                        :items.sync="itemValue.query"
                        :show-label="false"
                        :editable="editable"
                    ></ApiParameterEditor>
                </v-tab-item>
                <v-tab-item class="api-config">
                    <ApiParameterEditor
                        :items.sync="itemValue.header"
                        :show-label="false"
                        :editable="editable"
                    ></ApiParameterEditor>
                </v-tab-item>
                <v-tab-item class="api-config">
                    <v-radio-group
                        v-model="typeBody"
                        row
                        :disabled="!editable"
                        @change="handleChangeOptionBody"
                    >
                        <v-radio
                            label="none"
                            :value="TypeBody.NONE"
                            color="#0052CC"
                        ></v-radio>
                        <v-radio
                            label="Key - Value"
                            :value="TypeBody.KEY_VALUE"
                            color="#0052CC"
                            style="margin-left: 20px"
                        ></v-radio>
                        <v-radio
                            hide-details
                            label="JSON"
                            :value="TypeBody.JSON"
                            color="#0052CC"
                            style="margin-left: 20px"
                        ></v-radio>
                    </v-radio-group>
                    <ApiParameterEditor
                        :items.sync="body"
                        :editable="editable"
                        :show-label="false"
                        v-if="typeBody === 'key-value'"
                        @save="itemValue.body = body"
                    ></ApiParameterEditor>
                    <div v-if="typeBody === 'json'" class="hide-menu" @focusout="itemValue.body = body">
                        <VueJsonEditor
                            class="mt-8"
                            v-model="body"
                            mode="code"
                            :expanded-on-start="false"
                        ></VueJsonEditor>
                    </div>
                </v-tab-item>
                <v-tab-item class="api-config">
                    <div class="mt-8 settings">
                        <!--Enable or Disable API-->
                        <div class="setting-item">
                            <div style="flex: 1; font-family: 'open sans semi',serif">{{
                                    $f.tc('enableOrDisableAPI')
                                }}
                            </div>
                            <div style="width: 38px">
                                <v-switch
                                    v-model="itemValue.enableApi"
                                    color="#0052CC"
                                    :readonly="!editable"
                                ></v-switch>
                            </div>
                        </div>
                        <!--Allow API async-->
                        <div class="setting-item">
                            <div style="flex: 1; font-family: 'open sans semi',serif">{{
                                    $f.tc('allowApiAsync')
                                }}
                            </div>
                            <div style="width: 38px">
                                <v-switch
                                    v-model="itemValue.allow_async"
                                    color="#0052CC"
                                    :readonly="!editable"
                                ></v-switch>
                            </div>
                        </div>
                        <!--Set timeout API-->
                        <div class="setting-item">
                            <div style="font-family: 'open sans semi',serif">{{ $f.tc('setTimeoutAPI') }} (s)</div>
                            <div style="width: 80px">
                                <v-text-field
                                    hide-details
                                    :placeholder="'8'"
                                    v-model="timeout"
                                    @focusout="itemValue.timeout = timeout"
                                    class="input-custom"
                                    :readonly="!editable"
                                ></v-text-field>
                            </div>
                        </div>
                        <!--Config conditions API-->
                        <div
                            class="setting-item"
                            style="justify-content: flex-start !important;"
                            :style="showConditions ? {background: '#0000000a', borderBottom: 'none'} : ''"
                        >
                            <div style="font-family: 'open sans semi',serif">{{ $f.tc('conditionCallAPI') }}</div>
                            <div class="btn-icon ml-6" @click="showConditions = !showConditions">
                                <v-icon :style="showConditions ? {transform: 'rotate(-180deg)'} : ''">
                                    mdi-chevron-down
                                </v-icon>
                            </div>
                        </div>
                        <div v-if="showConditions" class="px-12 py-12" style="border-bottom: 1px solid #D9D9D9;">
                            <ConditionEditor :items="conditions" @save="updateConditions"></ConditionEditor>
                        </div>
                        <!--Config response API-->
                        <div
                            class="setting-item"
                            style="justify-content: flex-start !important;"
                            :style="showConfigResponse ? {background: '#0000000a', borderBottom: 'none'} : ''"
                        >
                            <div style="font-family: 'open sans semi',serif">{{ $f.tc('configResponseAPI') }}</div>
                            <div class="btn-icon ml-6" @click="showConfigResponse = !showConfigResponse">
                                <v-icon :style="showConfigResponse ? {transform: 'rotate(-180deg)'} : ''">
                                    mdi-chevron-down
                                </v-icon>
                            </div>
                        </div>
                        <div v-if="showConfigResponse" class="expand-item">
                            <VariablesForm v-model="itemValue.configResponses" :readonly="!editable"
                                           :config="itemValue.configResponses"></VariablesForm>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
        <div class="divider-tabs"></div>
    </div>
</template>

<script>
import lodash from "lodash"
import ApiParameterEditor from '@/views/Scenario/NodeEditor/common/ApiParameterEditor'
import VariablesForm from '@/components/VariablesForm'
import VueJsonEditor from 'vue-json-editor'
import ConditionEditor from '@/views/Scenario/NodeEditor/common/ConditionEditor'

const TypeBody = {
    NONE: 'none',
    KEY_VALUE: 'key-value',
    JSON: 'json',
}

export default {
    name: 'ApiEditor',
    components: { ConditionEditor, VariablesForm, VueJsonEditor, ApiParameterEditor },
    props: {
        item: Object,
        editable: {
            type: Boolean,
            default: true
        },
    },
    data () {
        return {
            TypeBody,
            itemValue: {},
            methodList: [
                { text: 'GET', value: 'GET' },
                { text: 'POST', value: 'POST' }
            ],
            typeBody: TypeBody.NONE,
            conditions: [],
            showConditions: false,
            showConfigResponse: false,
            body: {},
            url: '',
            timeout: '8',
            allow_async: false,
            activeTabAPI: 3,
            APITabs: [
                { name: 'Params', id: 'params_api_tab' },
                { name: 'Headers', id: 'headers_api_tab' },
                { name: 'Body', id: 'bodies_api_tab' },
                { name: 'Settings', id: 'settings_api_tab' },
            ],
        }
    },
    mounted () {
        this.updateApiCardInfo()
    },
    methods: {
        save () {
            if (!lodash.isEqual(this.itemValue, this.item)) {
                this.$emit('update:item', this.itemValue)
                this.$emit('save')
            }
        },
        updateApiCardInfo () {
            this.typeBody = this.itemValue.body ? TypeBody.KEY_VALUE : TypeBody.NONE
            this.body = this.itemValue.body
            this.url = this.itemValue.url ? this.itemValue.url : ''
            this.timeout = this.itemValue.timeout ? this.itemValue.timeout : '8'
            this.allow_async = this.itemValue.allow_async ? this.itemValue.allow_async : false
        },
        updateConditions () {
            this.itemValue.conditions = this.$utils.cloneObject(this.conditions)
        },
        handleChangeOptionBody() {
            this.itemValue.body = this.typeBody === TypeBody.NONE ? null : (this.itemValue.body ? this.itemValue.body : {})
        }
    },
    watch: {
        item: {
            immediate: true,
            deep: true,
            handler: function (item) {
                this.itemValue = item ? JSON.parse(JSON.stringify(item)) : {}
                this.conditions = this.itemValue.conditions ? this.$utils.cloneObject(this.itemValue.conditions) : []
                this.showConditions = this.conditions.length > 0
                this.updateApiCardInfo()
            }
        },
        itemValue: {
            deep: true,
            handler: 'save'
        },
    }
}
</script>

<style scoped lang="scss">
.api-title {
    font-weight: bold;
    font-size: 14px;
}

.api-config {
    padding-top: 18px;
    font-family: "open sans", serif;
    font-size: 14px;

    ::v-deep .v-messages {
        display: none;
    }
}

.method-api {
    width: 90px;
    font-family: "open sans semi", serif !important;

    ::v-deep {
        .v-input__slot {
            background: #F2F2F2 !important;
            border-radius: 5px 0 0 5px !important;
            padding: 0 6px 0 12px !important;
            border-right: none !important;
        }
    }
}

.url-path {
    flex: 1;

    ::v-deep {
        .v-input__slot {
            border-radius: 0 5px 5px 0 !important;
        }
        .v-text-field input {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
}

.divider-tabs {
    position: absolute;
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    left: 0;
    top: 148px;
}

.settings {
    border: 1px solid #D9D9D9;

    .setting-item {
        display: flex;
        align-items: center;
        padding: 0 12px;
        justify-content: space-between;
        height: 48px;
        line-height: 48px;
        border-bottom: 1px solid #D9D9D9;

        &:hover {
            background: #0000000a;
        }

        &:last-child {
            border-bottom: none !important;
        }
    }

    .expand-item {
        display: flex;
        align-items: center;
        padding: 12px;
    }

    ::v-deep {
        .v-input--selection-controls__input {
            margin-right: 0 !important;
        }

        .v-input--selection-controls {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.hide-menu {
    ::v-deep .jsoneditor-menu {
        display: none;
    }
}

::v-deep {
    .v-tabs__container {
        border-top: 1px solid #E4EDFA;
        padding: 0 !important;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-tabs__container {
        border-top: none;
        border-bottom: none !important;
    }

    .v-radio {
        margin-right: 0 !important;

        .v-input--selection-controls__input {
            margin-right: 2px !important;
        }

        .v-icon {
            font-size: 22px;
        }
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 8px !important;
        padding-bottom: 4px !important;
    }

    .v-input--selection-controls.v-input .v-label {
        font-size: 14px;
        color: #262626;
        font-family: "open sans", serif;
    }

    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-input--selection-controls__ripple {
        display: none;
    }

    input:focus::placeholder {
        color: transparent;
    }

    input::placeholder {
        color: #8A97AA;
    }
}
</style>
